import { createFileRoute } from "@tanstack/react-router";
import { faqJsonLd, jsonLdScript, pageHead } from "@/components/site/seo-copy";
import AppointmentSettingView from "@/components/cl/views/AppointmentSettingView";

const faqs = [
  {
    q: "Do you really hire the setters?",
    a: "Yes. We recruit, train and manage them in-house. They work for Closdd, so you never manage anyone.",
  },
  { q: "Do you close the deals as well?", a: "No. We book qualified appointments. Your team takes the calls." },
  {
    q: "Whose name do the setters use?",
    a: "Yours. They represent your business, your offer and your brand.",
  },
  {
    q: "What do you need from us?",
    a: "A clear offer, leads to work, and a calendar for us to book into.",
  },
  {
    q: "How is it priced?",
    a: "It depends on your sector and volume. We quote after the free sales audit.",
  },
];

export const Route = createFileRoute("/appointment-setting")({
  head: () => ({
    ...pageHead("/appointment-setting"),
    scripts: [jsonLdScript(faqJsonLd(faqs))],
  }),
  component: AppointmentSettingView,
});
